// src/components/admin/flows/canvas/CanvasControls.js
import React from 'react';
import { ZoomIn, ZoomOut, Maximize } from 'lucide-react';
import { useTheme } from '../../../../contexts/ThemeContext';

const CanvasControls = ({ zoom, onZoomIn, onZoomOut, onFitToScreen }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const btnClass = `p-2 rounded-lg transition-colors ${
        isDark
            ? 'bg-gray-700 hover:bg-gray-600 text-gray-300'
            : 'bg-white hover:bg-gray-100 text-gray-600'
    } border ${isDark ? 'border-gray-600' : 'border-gray-200'} shadow-sm`;

    return (
        <div className="absolute bottom-4 right-4 flex items-center gap-1.5 z-10">
            <button onClick={onZoomOut} className={btnClass} title="Zoom out">
                <ZoomOut className="w-4 h-4" />
            </button>
            <span className={`px-2 py-1.5 text-xs font-medium rounded-lg ${
                isDark ? 'bg-gray-700 text-gray-300 border-gray-600' : 'bg-white text-gray-600 border-gray-200'
            } border shadow-sm min-w-[48px] text-center`}>
                {Math.round(zoom * 100)}%
            </span>
            <button onClick={onZoomIn} className={btnClass} title="Zoom in">
                <ZoomIn className="w-4 h-4" />
            </button>
            <button onClick={onFitToScreen} className={btnClass} title="Fit to screen">
                <Maximize className="w-4 h-4" />
            </button>
        </div>
    );
};

export default CanvasControls;
